/**
 * IndexedDB teardown a later trigger recovers from: browsers drop connections,
 * transactions and cursors on frozen or memory-pressured tabs, which on iOS
 * Safari arrives as a bare `UnknownError` (GGA-APP-1SV).
 */
const RECOVERABLE_STORAGE_ERROR_NAMES = new Set([
  "AbortError",
  "BulkError",
  "DatabaseClosedError",
  "InvalidStateError",
  "ModifyError",
  "TransactionInactiveError",
  "UnknownError",
]);

// Safari's TypeError right after it lost the IndexedDB connection (GGA-APP-1NK)
const SAFARI_INDEXED_DB_TYPE_ERROR_MESSAGE = "Internal error";

export function isRecoverableStorageError(err: unknown): boolean {
  if (err instanceof TypeError) {
    return err.message === SAFARI_INDEXED_DB_TYPE_ERROR_MESSAGE;
  }
  return err instanceof Error && RECOVERABLE_STORAGE_ERROR_NAMES.has(err.name);
}
